export enum EDashboardPage {
  VinDecodeHistory = 'vin-decode-history',
}

export enum EStatsType {
  Services,
  InnerMonthly,
  InnerTotal,
}

export enum EStatsService {
  AuctionPosted,
  AuctionSold,
  SrsRecoveries,
  SrsAuction,
  VRM,
  ExpressRecoveriesVehicles,
  ExpressRecoveriesProducts,
  Reindeer,
}

export enum EStatsInner {
  VinDecodeSuccess,
  VinDecodeFailed,
  AdsTotal,
  AdsRunning,
  InvoiceAmount,
  AuctionBids,
}
